import script from "./FindRoommateView.vue?vue&type=script&setup=true&lang=js"
export * from "./FindRoommateView.vue?vue&type=script&setup=true&lang=js"

import "./FindRoommateView.vue?vue&type=style&index=0&id=81e41a20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81e41a20"]])

export default __exports__